import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Dingley – Recycled Water Scheme Pump Station</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
        We’re building a Recycled Water Pump Station to keep recycled water flowing through the 42km pipeline.
        </p>
        <p>
        Our industry partner Abergeldie, KBR, BMD Joint Venture (ABK) started construction on the Pump Station in February 2026. We expect construction to take approximately 12 months.
        </p>
        <p>
          For more information click{' '}
          <a
            href="https://southeastwater.com.au/residential/upgrades-and-projects/projects/dingley-recycled-water-scheme/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Dingley - Recycled Water Scheme Pump Station (Stage 1)',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800330129">1800 330 129</a> |{' '}
          <a
            href="mailto:dingley@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: DINGLEY@SEW.COM.AU - Dingley - Recycled Water Scheme Pump Station (Stage 1)',
              });
            }}
          >
            dingley@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;

